import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, mergeMap } from 'rxjs';

import { SegmentTrackEvent } from '@ninety/platform/models/analytics/segment/segment-track-event.enum';
import { SegmentActions } from '@ninety/platform/state/app-global/analytics/segment/segment.actions';

import { MeetingPrepPanelActions } from './meeting-prep-panel.actions';
import { MEETING_PREP_CTA_ID_BY_ITEM } from './meeting-prep-panel.model';

@Injectable()
export class MeetingPrepPanelAnalyticsEffects {
  private readonly actions$ = inject(Actions);

  trackMazCtasShown$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MeetingPrepPanelActions.mazCtasShown),
      mergeMap(({ teamId, isOnMyNinety }) =>
        // eslint-disable-next-line @ngrx/no-multiple-actions-in-effects
        Object.values(MEETING_PREP_CTA_ID_BY_ITEM).map(ctaId =>
          SegmentActions.track({
            event: SegmentTrackEvent.RNA_MEETING_PREP_MAZ_CTA_SHOWN,
            params: { ctaId, teamId, isOnMyNinety },
          })
        )
      )
    )
  );

  trackMazCtaClicked$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MeetingPrepPanelActions.mazCtaClicked),
      map(({ ctaId, teamId, isOnMyNinety }) =>
        SegmentActions.track({
          event: SegmentTrackEvent.RNA_MEETING_PREP_MAZ_CTA_CLICKED,
          params: { ctaId, teamId, isOnMyNinety },
        })
      )
    )
  );
}
